
import { useState, useEffect, useRef } from 'react';
import "../../../../assets/css/slotplaning/slotplanning.css";
import Header from "../../../../Components/Header/Header";
import LeftMenu from '../../../../Components/LeftMenu/LeftMenu';
import TopMenu from '../../../../Components/TopMenu/TopMenu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus, faExpand, faXmark, faPaperclip, faBolt, faChevronDown, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { Timeline } from 'vis-timeline/standalone';
import 'vis-timeline/styles/vis-timeline-graph2d.min.css';
import Truckdash from "../../../../assets/images/truck_dash.png";
import { withRFSToken } from '../../../../Services/axios.js';
import { Container, Row, Col, Modal, Button, Tab, Tabs, Dropdown, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { SLOTPLANNINGWAREHOUSE, SLOTPLANNINGPLANNINGDASHBOARD, SLOTDETAILS, SLOTPLANNINGDOORUPDATE, SLOTPLANNINGDOORSAVE, SLOTPLANNINGMETADATA } from '../../../../Utils/conts.js';
import Cargotruck from "../../../../assets/images/cargo-truck.png";
import Planemap from "../../../../assets/images/plane_map.png";
import Door from "../../../../assets/images/door.png";
import EditPencil from "../../../../assets/images/editpencil.png";
import ImageUpload from '../../../../Components/common/ImageUpload';
import ActivityComments from '../../../../Components/common/ActivityComments';
import Select from 'react-select';
import { toast } from 'react-toastify';
import CommonCard from '../../../../Components/common/CommonCard.js';

import tripstoday from '../../../../assets/images/slotplanning/tripstoday.svg';
import onpremises from '../../../../assets/images/slotplanning/onpremises.svg';
import inprogress from '../../../../assets/images/slotplanning/inprogress.svg';
import arriving from '../../../../assets/images/slotplanning/arriving.svg';

// import { SLOTPLANNINGMETADATA, SLOTPLANNINGWAREHOUSE, GETOWNERCODE, SLOTPLANNINGDOORSAVE, SLOTPLANNINGDOORDELETERESTORE, SLOTPLANNINGSETDOORCONFIGURATION, SLOTPLANNINGDOORUPDATE } from '../../../Utils/conts.js';
const PlanningDashboard = () => {
    const isMounted = useRef(false);
    const timelineRef = useRef(null);
    const doorStatusMapRef = useRef({});
    const [currentTime, setCurrentTime] = useState(new Date());
    const [timeline, setTimeline] = useState(null);
    const [timelineDisplay, setTimelineDisplay] = useState('T');
    const [getTruckData, setGetTruckData] = useState([]);
    const [groups, setGroups] = useState([]);
    const [isDataReady, setIsDataReady] = useState(false);
    const [warehouselist, setWarehouselist] = useState([]);
    const [activeWarehouse, setActiveWarehouse] = useState(null);
    const activeWarehouseRef = useRef();
    const fetchedDatesRef = useRef(new Set());
    const [fullScreen, setFullScreen] = useState(false);
    const [activeDoorSelect, setActiveDoorSelect] = useState();
    const [doorDetailsModal, setDoorDetailsModal] = useState(false);
    const [activeDoorDetails, setActiveDoorDetails] = useState();
    const [showFlightDetails, setShowFlightDetails] = useState(null);
    const [slotStatuses, setSlotStatuses] = useState({});
    const [modalShow, setModalShow] = useState(0);
    const [tripType, setTripType] = useState([]);
    const [cargoType, setCargoType] = useState([]);
    const [vehicleType, setVehicleType] = useState([]);
    const [specialCargoType, setSpecialCargoType] = useState([]);
    const [airlinePrefixOptions, setAirlinePrefixOptions] = useState([]);
    const [formatedDate, setFormatedDate] = useState([]);
    const [confModal, setConfModal] = useState(false);
    const [selectedDoor, setSelectedDoor] = useState("")
    const [isUltraWide, setIsUltraWide] = useState(window.innerWidth >= 2400);
    const [doorStatusFormData, setDoorStatusFormData] = useState(window.innerWidth >= 2400);
    const [filteredDoorStatus, setFilteredDoorStatus] = useState();

    const airlineAccessOptions = [
        { label: 'Exclusive', value: 'E' },
        { label: 'Preferred', value: 'P' }
    ];
    const specialCargoHandlingTypeOptions = [
        { label: 'Exclusive', value: 'E' },
        { label: 'Preferred', value: 'P' }
    ];

    
    const [dashboardCards, setDashboardCards] = useState();
    const iconMap = { tripstoday, onpremises, inprogress, arriving, };

    const fetchWareHouseData = async () => {
        try {
            let Handler_stn = localStorage.getItem('Handler_stn');
            if (!Handler_stn) return;
            Handler_stn = JSON.parse(Handler_stn);
            const res = await withRFSToken.post(SLOTPLANNINGWAREHOUSE, { org_station_id: Handler_stn.org_station_id });
            const innerData = res.data.response_data;
            setWarehouselist(innerData.map(w => ({
                label: w.name,
                value: w.id,
                doors_count: w.doors_count,
            })));
            if (innerData.length > 0) {
                setActiveWarehouse(innerData[0].id);
                activeWarehouseRef.current = innerData[0].id;

                // const today = new Date();
                // const yyyy = today.getFullYear();
                // const mm = String(today.getMonth() + 1).padStart(2, '0');
                // const dd = String(today.getDate()).padStart(2, '0');
                // const formattedDate = `${yyyy}-${mm}-${dd}`;
                // setFormatedDate(formattedDate);
                // fetchDoorDetails(formattedDate, false, innerData[0].id);
            }
        } catch (error) {
            console.error('Error fetching warehouse data:', error);
        }
    };

    const fetchMetaData = async () => {
        try {
            const res = await withRFSToken.post(SLOTPLANNINGMETADATA)
                .then(function (res) {
                    const trip_type = res.data.response_data.trip_type;
                    setTripType(trip_type.map(w => ({
                        label: w.name,
                        value: w.id
                    })));
                    const cargo_type = res.data.response_data.cargo_type;
                    setCargoType(cargo_type.map(w => ({
                        label: w.name,
                        value: w.id
                    })));
                    const vehicle_type = res.data.response_data.vehicle_type;
                    setVehicleType(vehicle_type.map(w => ({
                        label: w.name,
                        value: w.id
                    })));
                    const special_cargo_type = res.data.response_data.special_cargo_type;
                    setSpecialCargoType(special_cargo_type.map(w => ({
                        label: w.name,
                        value: w.id
                    })));
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const closeConfirm = () => {
        const switchElement = document.querySelector(`input[data-group-id="${activeDoorSelect}"]`);
        setConfModal(false);
        switchElement.checked = true;
    }

    const handleConfirmation = (confirm) => {
        if (confirm) {
            handleUpdateDoor(activeDoorSelect, 0, "P");
            setConfModal(false);
        } else {
            const switchElement = document.querySelector(`input[data-group-id="${activeDoorSelect}"]`);
            if (switchElement) {
                switchElement.checked = true;
                switchElement.classList.remove('slot_inactive');
                switchElement.classList.add('slot_active');
            }
            closeConfirm();
        }
    };

    setInterval(() => {
        fetchedDatesRef.current.clear();
    }, 1 * 60 * 1000);

    // const fetchDoorDetails = async (date) => {
    //     if (fetchedDatesRef.current.has(date)) return;
    //     try {
    //         const res = await withRFSToken.post(SLOTPLANNINGPLANNINGDASHBOARD, {
    //             warehouse_id: activeWarehouseRef.current,
    //             date: date
    //         });
    //         fetchedDatesRef.current.add(date);
    //         const doorData = res.data.response_data || [];
    //         const newItems = [];
    //         const newGroups = [];
    //         doorData.forEach((door) => {
    //             const groupId = `${door.door_id}`;
    //             let doorStatus;
    //             if (!groups.find(g => g.id === groupId)) {
    //                 if (door.status == 1) {
    //                     doorStatus = "\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0";
    //                     // doorStatus="Active";
    //                 } else {
    //                     doorStatus = "\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0";
    //                     // doorStatus="Deactive";
    //                 }
    //                 newGroups.push({ id: groupId, content: `<div>${door.door_no} <div>${doorStatus}</div></div>`, className: "door_" + doorStatus + "", });
    //             }
    //             door.slots.forEach(slot => {
    //                 let dynamicClassName = '';
    //                 if (slot.status == "Open") {
    //                     dynamicClassName = "slot_open";
    //                 } else if (slot.status == "Completed") {
    //                     dynamicClassName = "slot_complete";
    //                 } else if (slot.status == "In Progress") {
    //                     dynamicClassName = "slot_progress";
    //                 }
    //                 console.log(`${date} ${slot.start}`);

    //                 newItems.push({
    //                     id: `${door.door_id}---${slot.id}`,
    //                     group: groupId,
    //                     content: `<div><img src="${Truckdash}" alt="Truck" /><span> ${slot.trip_type}</span><span> ${slot.status}</span><p>${slot.start.split(' ')[1].slice(0, 5)} - ${slot.end.split(' ')[1].slice(0, 5)}</p></div>`,
    //                     // start: `${date} ${slot.start}`,
    //                     // end: `${date} ${slot.end}`,
    //                     start: slot.start,
    //                     end: slot.end,
    //                     className: dynamicClassName,
    //                 });
    //             });
    //         });
    //         if (doorData.length === 0) {
    //             const emptyGroupId = `${date}-empty`;
    //             if (!groups.find(g => g.id === emptyGroupId)) {
    //                 newGroups.push({ id: emptyGroupId, content: `No Slots (${date})` });
    //             }
    //         }
    //         setGroups(prev => {
    //             const existingIds = new Set(prev.map(g => g.id));
    //             const filteredNewGroups = newGroups.filter(g => !existingIds.has(g.id));
    //             return [...prev, ...filteredNewGroups];
    //         });
    //         setGetTruckData(prev => [...prev, ...newItems]);
    //     } catch (error) {
    //         console.error('Error fetching door details:', error);
    //     }
    // };

    window.handleSwitchToggle = function (event) {
        const input = event.target;
        const groupId = input.getAttribute('data-group-id');
        const doorNo = input.getAttribute('data-door-no');
        setSelectedDoor(doorNo)
        const isChecked = input.checked;
        if (isChecked) {
            input.classList.remove('bg-danger');
            input.classList.add('bg-success');
            handleUpdateDoor(groupId, 1, "P");
        } else {
            setConfModal(true);
            setActiveDoorSelect(groupId);
            input.classList.remove('bg-success');
            input.classList.add('bg-danger');
        }
        console.log("Switch toggled:", {
            groupId,
            status: isChecked ? 1 : 0
        });
        // handleUpdateDoor(groupId, isChecked ? 1 : 0, "P");
        const toggleEvent = new CustomEvent("doorToggle", {
            detail: { groupId, status: isChecked ? 'on' : 'off' }
        });
        window.dispatchEvent(toggleEvent);
    };

    const refreshPageData = () => {
        fetchDoorDetails();
        // refreshGrid();
    }

    const handleConfirmDoorDetails = (confirm) => {
        if (confirm) {
            // handleDoorDelete(deleteId)
            // setConfModal(false);
            handleUpdateDoor(activeDoorSelect, 0, "C");
            setDoorDetailsModal(false);
        } else {
            // setDeleteId(0);
            setDoorDetailsModal(false);
        }
    };

    const handleUpdateDoor = async (door_id, action, actionType) => {
        setActiveDoorSelect(door_id);
        let action_type;
        if (action == 1) {
            action_type = "C";
        }
        if (action == 0) {
            action_type = actionType;
        }
        const alldata = {
            door_id: door_id,
            action: action,
            action_type: action_type,
            slot_details: finalSlotDetails,
            remarks: doorStatusFormData.remarks,
            reason: doorStatusFormData.reason
        };
        try {
            const res = await withRFSToken.post(SLOTPLANNINGDOORUPDATE, alldata)
                .then(function (res) {
                    if (res.data.response_code == 200) {
                        toast.success(res.data.response_msg);
                    } else if (res.data.response_code == 403) {
                        setDoorDetailsModal(true);
                        setActiveDoorDetails(res.data?.response_data);
                    } else if (res.data.response_code == 402) {
                        toast.error(res.data.response_msg);
                    } else {
                        toast.error(res.data.response_msg);
                    }
                    refreshPageData();
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const finalSlotDetails = {
        assigned_slots: activeDoorDetails?.assigned_slots?.map(slot => ({
            ...slot,
            status: slotStatuses?.[slot.old_slot?.slot_id] ?? 0,
        })) ?? [],
        not_assigned_slots: activeDoorDetails?.not_assigned_slots ?? [],
    };

    const [formData, setFormData] = useState({
        warehouse_id: '',
        door_no: '',
        activity_status: 1,
        trip_type_ids: [],
        cargo_type_ids: [],
        vehicle_type_ids: [],
        side_loading: 1,
        airline_assigment_rule: 0,
        airline_access_type: '',
        airline_prefixes: [],
        special_cargo_handling: 0,
        special_cargo_handling_type: '',
        special_cargo_types: []
    });

    const handleBooleanChange = (name, boolValue) => {
        setFormData(prev => ({ ...prev, [name]: boolValue }));
    };

    const handleInputChange = (e) => {
        let { name, value } = e.target;
        if (name == "door_no") {
            value = value.toUpperCase();
        }
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const fetchDoorDetails = async (date, reset = false, ) => {
        if (!date) {
            date = formatedDate;
        }
        try {
            if (reset) {
                setGroups([]);
                setGetTruckData([]);
            }
            const res = await withRFSToken.post(SLOTPLANNINGPLANNINGDASHBOARD, {
                warehouse_id: activeWarehouseRef.current,
                date: date
            });
            fetchedDatesRef.current.add(date);
            let doorData = res?.data?.response_data?.dashboard_data || [];
            let stats = res?.data?.response_data?.stats || {};
           
            const updatedCards = {...res?.data?.response_data?.stats, ...res?.data?.response_data?.trip_stats}

            setDashboardCards(updatedCards);
            if (filteredDoorStatus !== null && filteredDoorStatus !== undefined) {
                doorData = doorData.filter(door => door.status === filteredDoorStatus);
            }

            const newItems = [];
            const newGroups = [];
            doorData.forEach((door) => {
                const groupId = `${door.door_id}`;

                let doorStatus;
                if (!newGroups.find(g => g.id === groupId)) {
                    doorStatus = "\u00A0".repeat(35);
                    const doorContent = document.createElement("div");
                    if (filteredDoorStatus === 0) {
                        doorContent.classList.add("door_hidden")
                    } else if (filteredDoorStatus === 1) {
                        doorContent.classList.remove("door_hidden")
                    }
                    doorContent.innerHTML = `<div class="d-flex justify-content-between"><div class="door_text">${door.door_no}</div></div>
                                            <div class="d-flex mt-1 align-items-center">
                                            <div class="pe-2 door_activeinactive_status">${door.status === 1 ? 'Active' : 'Inactive'}</div>
                                            <div class="form-check form-switch">                                
                                                <input 
                                                class="form-check-input ${door.status === 1 ? 'slot_active' : 'slot_inactive'} switchActiveInactive" 
                                                type="checkbox" 
                                                role="switch" 
                                                ${door.status === 1 ? 'checked' : ''}
                                                data-group-id="${groupId}"
                                                data-door-no="${door.door_no}"
                                                onchange="handleSwitchToggle(event)"
                                                />
                                            </div></div>`+ doorStatus;

                    newGroups.push({
                        id: groupId,
                        content: doorContent,
                        className: "door_" + groupId + "",
                    });
                }
                if (door.status === 0) {
                    const formatDate = (selectedDate) => {
                        const year = String(selectedDate.getFullYear());
                        const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
                        const day = String(selectedDate.getDate()).padStart(2, '0');
                        const hours = String(selectedDate.getHours()).padStart(2, '0');
                        const minutes = String(selectedDate.getMinutes()).padStart(2, '0');
                        const seconds = String(selectedDate.getSeconds()).padStart(2, '0');
                        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
                    };

                    const today = new Date(date);
                    const dayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1, 0, 0, 0);
                    const dayEnd = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1, 7, 0, 0);

                    newItems.push({
                        id: `${door.door_id}---inactive`,
                        group: groupId,
                        content: `Reason: ${door.reason || 'N/A'} <br/> Remarks: ${door.remarks || 'N/A'}`,
                        start: formatDate(dayStart),
                        end: formatDate(dayEnd),
                        className: 'slot_empty',
                        type: "background"
                    });
                }
                else if (door.status === 1) {
                    door?.slots?.forEach(slot => {
                        let dynamicClassName = '';
                        if (slot?.trip_status?.id == "207") dynamicClassName = "slot_timeslot_booked";
                        else if (slot?.trip_status?.id == "208") dynamicClassName = "slot_arrived";
                        else if (slot?.trip_status?.id == "209") dynamicClassName = "slot_checked_in";
                        else if (slot?.trip_status?.id == "210") dynamicClassName = "slot_started";
                        else if (slot?.trip_status?.id == "211") dynamicClassName = "slot_completed";
                        else if (slot?.trip_status?.id == "212") dynamicClassName = "slot_checked_out";
                        else if (slot?.trip_status?.id == "213") dynamicClassName = "slot_completed";
                        const slotContent = document.createElement("div");
                        slotContent.classList.add("my-class");
                        // let truckNo = [...new Set(slot?.truck_no?.map(truck_no => truck_no).filter(Boolean))].join(", ");
                        slotContent.innerHTML = `
                                <div style="display: flex; justify-content: space-between; width: 100%;">
                                    <span>${slot?.trip_type} - ${slot?.truck_no}</span>
                                    <span>${slot?.trip_status?.name}</span>
                                </div>
                                <div style="display: flex; justify-content: space-between; width: 100%;">
                                    <span>${slot?.start?.split(' ')[1].slice(0, 5)} - ${slot?.end?.split(' ')[1].slice(0, 5)}</span>
                                </div>
                            `
                        newItems.push({
                            id: `${door?.door_id}---${slot?.id}`,
                            group: groupId,
                            content: slotContent,
                            start: slot?.start,
                            end: slot?.end,
                            className: dynamicClassName,
                        });
                    });
                }
            });
            if (doorData.length === 0) {
                const emptyGroupId = `${date}-empty`;
                if (!newGroups.find(g => g.id === emptyGroupId)) {
                    newGroups.push({ id: emptyGroupId, content: `No Slots (${date})` });
                }
            }
            doorStatusMapRef.current = {};
            doorData.forEach(door => {
                doorStatusMapRef.current[door.door_id] = door.status;
            });
            setGroups(newGroups);
            setGetTruckData(newItems);
            setIsDataReady(true);
        } catch (error) {
            console.error('Error fetching door details:', error);
        }
    };

    const cards = [
        { id: 1, icon: 'tripstoday', title: 'Trips Today', value: dashboardCards?.today_count ?? '-' },
        { id: 2, icon: 'onpremises', title: 'Trips - Next 8 Hours', value: dashboardCards?.next_8_hours_count ?? '-' },
        { id: 3, icon: 'inprogress', title: 'Arrived', value: dashboardCards?.arrived_count ?? '-' },
        { id: 3, icon: 'inprogress', title: 'In Progress', value: dashboardCards?.in_progress_count ?? '-' },
        { id: 4, icon: 'arriving', title: 'SLA Delay', value: dashboardCards?.sla_delay_count ?? '-' },
    ];

    useEffect(() => {
        if (isMounted.current) return;
        fetchWareHouseData();
        fetchMetaData();
        isMounted.current = true;
    }, []);

    useEffect(() => {
        if (activeWarehouse !== null && activeWarehouse !== undefined && activeWarehouse !== '') {
            const today = new Date();
            const yyyy = today.getFullYear();
            const mm = String(today.getMonth() + 1).padStart(2, '0');
            const dd = String(today.getDate()).padStart(2, '0');
            const formattedDate = `${yyyy}-${mm}-${dd}`;
            setFormatedDate(formattedDate);
            fetchDoorDetails(formattedDate);
        }
    }, [activeWarehouse]);

    useEffect(() => {
        if (formatedDate) {
            fetchDoorDetails(formatedDate);
        }
    }, [filteredDoorStatus]);

    useEffect(() => {
        if ((getTruckData.length > 0 || groups.length > 0) && timelineDisplay === 'T') {
            setIsDataReady(true);
        }
    }, [getTruckData, groups, timelineDisplay]);

    // useEffect(() => {
    //     if (isDataReady && timelineDisplay) {
    //         // const timelineStart = new Date(currentTime);
    //         // timelineStart.setHours(9, 0, 0, 0);
    //         // const timelineEnd = new Date(currentTime);
    //         // timelineEnd.setHours(12, 0, 0, 0);
    //         if (timeline) {
    //             timeline.destroy();
    //         }
    //         const now = new Date();
    //         const timelineStart = new Date(now.getTime() - 60 * 60 * 1000);
    //         const timelineEnd = new Date(now.getTime() + 2 * 60 * 60 * 1000);
    //         const options = {
    //             stack: false,
    //             margin: { item: 10, axis: 10 },
    //             start: timelineStart,
    //             end: timelineEnd,
    //             editable: false,
    //             zoomable: false,
    //             groupHeightMode: 'fixed',
    //             horizontalScroll: true,
    //             // height:"300px",
    //             orientation: { axis: 'both', item: 'bottom' },
    //             format: {
    //                 minorLabels: {
    //                     minute: 'HH:mm'
    //                 },
    //                 majorLabels: {
    //                     hour: 'HH:mm'
    //                 }
    //             }
    //         };

    //         const newTimeline = new Timeline(timelineRef.current, [], [], options);
    //         newTimeline.moveTo(now);
    //         newTimeline.on("rangechanged", (props) => {
    //             const startDate = new Date(props.start);
    //             const formattedDate = startDate.toISOString().split('T')[0];
    //             fetchDoorDetails(formattedDate);
    //             // setTimeout(() => {
    //             //     window.$('.asfdasds').css('height', '85px');
    //             // }, 1000);
    //         });

    //         newTimeline.on("click", function (props) {
    //             if (props.item) {
    //                 const itemId = props.item;
    //                 const slotId = itemId.split('---')[1];
    //                 const doorId = itemId.split('---')[0];
    //                 console.log("Slot ID:", slotId);
    //                 console.log("Door ID:", doorId);

    //                 handleSidepannel(slotId)

    //                 // const clickedItem = getTruckData.find(item => item.id === props.item);
    //                 // console.log("Full Item Data:", clickedItem);
    //             }
    //         });

    //         setTimeline(newTimeline);
    //     }
    // }, [isDataReady, timelineDisplay.current]);

    useEffect(() => {
        let isDragging = false;
        if (isDataReady && timelineDisplay) {
            if (!timelineRef.current) return;
            if (timeline) {
                timeline.destroy();
            }
            const now = new Date();
            // 4.5 hours before and after current time
            // const halfWindowMs = 4 * 60 * 60 * 1000;
            const halfWindowMs = isUltraWide ? 6 * 60 * 60 * 1000 : 4 * 60 * 60 * 1000;
            const timelineStart = new Date(now.getTime() - halfWindowMs);
            const timelineEnd = new Date(now.getTime() + halfWindowMs);


            const options = {
                stack: true,
                margin: { item: 10, axis: 10 },
                start: timelineStart,
                end: timelineEnd,
                editable: {
                    add: false,           // don't allow adding new items
                    updateTime: true,     // allow dragging left/right (time change)
                    updateGroup: true,    // allow dragging up/down (group change)
                    remove: false,        // don't allow deleting items
                    overrideItems: false  // items can overlap
                },
                zoomable: false,
                groupHeightMode: 'fixed',
                horizontalScroll: true,
                orientation: { axis: 'both', item: 'bottom' },
                format: {
                    minorLabels: {
                        minute: 'DD MMM YYYY HH:mm'
                    },
                    majorLabels: {
                        hour: 'DD MMM YYYY HH:mm'
                    }
                },

                onMove: function (item, callback) {
                    const statusOpen = item.content.textContent.includes("Open");
                    const statusClose = item.content.textContent.includes("Completed");
                    const statusInProgress = item.content.textContent.includes("In Progress");
                    const targetGroupId = item.group;
                    const doorId = parseInt(targetGroupId);
                    const doorStatus = doorStatusMapRef.current[doorId];
                    if (doorStatus === 0) {
                        console.log('Cannot drag to inactive door');
                        toast.error("Cannot drag items to inactive doors");
                        callback(null);
                        return;
                    }

                    item.className = "vis-item";
                    if (statusOpen) {
                        item.className = "slot_open"
                    }
                    else if (statusClose) {
                        item.className = "slot_complete"
                    } else if (statusInProgress) {
                        item.className = "slot_progress"
                    }
                    callback(item);
                },
                onMoving: function (item, callback) {
                    isDragging = true;
                    const statusOpen = item.content.textContent.includes("Open");
                    const statusClose = item.content.textContent.includes("Completed");
                    // const statusInProgress = item.content.textContent.includes("In Progress");
                    item.className = `dragging-item-relased ${statusOpen ? 'slot_open' : (statusClose ? 'slot_complete' : 'slot_progress')}`;
                    callback(item);
                }
            };
            const newTimeline = new Timeline(timelineRef.current, [], [], options);
            newTimeline.moveTo(now);

            newTimeline.on('changed', () => {
                //    requestAnimationFrame(drawConnections);

                const updatedItems = newTimeline.itemsData.get();
            });

            newTimeline.on('move', (item, callback) => {
            });



            newTimeline.on("rangechanged", (props) => {
                const startDate = new Date(props.start);
                const formattedDate = startDate.toISOString().split('T')[0];
                fetchDoorDetails(formattedDate);
            });

            newTimeline.on("click", function (props) {
                if (!isDragging && props.item) {
                    const itemId = props.item;
                    const slotId = itemId.split('---')[1];
                    const doorId = itemId.split('---')[0];
                    handleSidepannel(slotId);
                }
                isDragging = false;
            });

            setTimeline(newTimeline);
        }

    }, [isDataReady, timelineDisplay]);

    useEffect(() => {
        if (timeline && getTruckData && groups) {
            try {
                timeline.setItems(getTruckData);
                timeline.setGroups(groups);

                setTimeout(() => {
                    const labelContainer = document.querySelector('.vis-timeline.vis-bottom.vis-ltr');
                    if (labelContainer && !document.querySelector('.custom-door-header')) {
                        const header = document.createElement('div');
                        header.className = 'custom-door-header';
                        header.innerHTML = '<img src="' + Door + '" alt="Door" class="door_head pe-2" />' + 'Doors';
                        header.style.fontWeight = 'bold';
                        header.style.padding = '5px 10px';
                        header.style.position = 'absolute';
                        header.style.width = '150px';
                        labelContainer.parentNode.insertBefore(header, labelContainer);
                    }
                }, 100);
            } catch (err) {
                console.error('Error setting timeline data:', err);
            }
        }
    }, [getTruckData, groups, timeline]);

    const handleSelectChange = (name, selectedOption) => {
        setActiveWarehouse(selectedOption.value);
        activeWarehouseRef.current = selectedOption.value;
        setGroups([]); // Clear groups
        setGetTruckData([]); // Clear items
        fetchedDatesRef.current = new Set();
        setIsDataReady(false);

        // Add this block to refetch current date's data
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const formattedDate = `${yyyy}-${mm}-${dd}`;
        fetchDoorDetails(formattedDate, true); // Pass true to indicate reset
    };

    // const handleSelectChange = (name, selectedOption) => {
    //     setActiveWarehouse(selectedOption.value);
    //     activeWarehouseRef.current = selectedOption.value;
    //     setGroups([]);
    //     setGetTruckData([]);
    //     fetchedDatesRef.current = new Set();
    //     setIsDataReady(false);

    //     // Add this block to refetch current date's data
    //     const today = new Date();
    //     const yyyy = today.getFullYear();
    //     const mm = String(today.getMonth() + 1).padStart(2, '0');
    //     const dd = String(today.getDate()).padStart(2, '0');
    //     const formattedDate = `${yyyy}-${mm}-${dd}`;
    //     fetchDoorDetails(formattedDate);
    // };

    const zoomIn = () => {
        if (timeline) {
            const range = timeline.getWindow();
            const interval = range.end - range.start;
            timeline.setWindow({
                start: new Date(range.start.getTime() + interval * 0.1),
                end: new Date(range.end.getTime() - interval * 0.1),
            });
        }
    };

    const zoomOut = () => {
        if (timeline) {
            const range = timeline.getWindow();
            const interval = range.end - range.start;
            timeline.setWindow({
                start: new Date(range.start.getTime() - interval * 0.1),
                end: new Date(range.end.getTime() + interval * 0.1),
            });
        }
    };
    const toggleFullScreen = () => {
        setFullScreen(prev => !prev);
    };

    const handleSidepannel = async (item) => {
        try {
            const res = await withRFSToken.post(SLOTDETAILS, { slot_id: item })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setShowFlightDetails(innerData);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const handleCloseClick = () => {
        setShowFlightDetails(null);
    }

    const handleModalClose = () => {
        setFormData({
            warehouse_id: '',
            door_no: '',
            activity_status: 1,
            trip_type_ids: [],
            cargo_type_ids: [],
            vehicle_type_ids: [],
            side_loading: 1,
            airline_assigment_rule: 1,
            airline_access_type: '',
            airline_prefixes: [],
            special_cargo_handling: 1,
            special_cargo_handling_type: '',
            special_cargo_types: []
        });
        setModalShow(false);
    };

    const handleAddDoor = async () => {
        try {
            const res = await withRFSToken.post(SLOTPLANNINGDOORSAVE, formData)
                .then(function (res) {
                    if (res.data.response_code == 200) {
                        toast.success(res.data.response_msg);
                        setModalShow(false);
                        setFormData({
                            warehouse_id: '',
                            door_no: '',
                            activity_status: 1,
                            trip_type_ids: [],
                            cargo_type_ids: [],
                            vehicle_type_ids: [],
                            side_loading: 1,
                            airline_assigment_rule: 1,
                            airline_access_type: '',
                            airline_prefixes: [],
                            special_cargo_handling: 1,
                            special_cargo_handling_type: '',
                            special_cargo_types: []
                        });
                        refreshPageData();
                    } else {
                        toast.error(res.data.response_msg);
                    }
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    // upload forward
    const imageUploadRef = useRef(null);
    const browseClick = () => {
        if (imageUploadRef.current) {
            imageUploadRef.current.handleBrowseFiles();
        }
    };
    // FILE UPLOAD END

    const handleSelectDoorStatus = (eventKey) => {
        let activeStatus;
        if (eventKey === "active") {
            activeStatus = 1;
        } else if (eventKey === "inactive") {
            activeStatus = 0;
        } else if (eventKey === "all") {
            activeStatus = null;
        }
        setFilteredDoorStatus(activeStatus);
    };

    const handleResize = () => {
        setIsUltraWide(window.innerWidth >= 2400);
    }

    useEffect(() => {
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    const handleDoorStatusChange = (fieldName, value) => {
        setDoorStatusFormData(prevFormData => ({
            ...prevFormData,
            [fieldName]: value
        }))
    };


    return (
        <>
            {/* <div className="">
                <Header page_type='Handler' logo_url='/PlanningDashboard' />
                <TopMenu module='SPL' />
                <div className="page-body-wrapper schedule">
                    <LeftMenu /> */}
            {/* <div className="main-panel rounded"> */}
            <div className="main-content">
                {cards?.length ?
                    <div className="card-bx">
                        {cards?.map((item, index) => (
                            <CommonCard icon={iconMap[item.icon]} title={item.title} value={item.value} />
                        ))}
                    </div>
                    : <></>
                }
                <div className={`mainTab ${fullScreen ? 'fullscreen_slot' : ''}`}>
                    <div className="mainTab d-flex justify-content-between align-items-center">
                        <div className='d-flex gap-2'>
                            <div className="">
                                <div className='d-flex'>
                                    <Select
                                        name="warehouse_id"
                                        options={warehouselist}
                                        value={warehouselist?.find(opt => opt.value === activeWarehouse)}
                                        onChange={(val) => handleSelectChange('warehouse_id', val)}
                                        placeholder="Warehouse"
                                    />
                                </div>
                            </div>
                            <div className='d-flex align-items-center'>
                                <Dropdown onSelect={handleSelectDoorStatus}>
                                    <Dropdown.Toggle variant="light" id="dropdown-basic" className='adduld'  >
                                        Filter Station <FontAwesomeIcon icon={faChevronDown} />
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu >
                                        <Dropdown.Item eventKey={"all"}> All </Dropdown.Item>
                                        <Dropdown.Item eventKey={"active"}> Active </Dropdown.Item>
                                        <Dropdown.Item eventKey={"inactive"}> Inactive </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>

                        </div>

                        <div className="d-flex align-items-end truck_filter">
                            <div className="ms-2 truck_plas">
                                <button type="button" className="btn btn-light" onClick={toggleFullScreen}> <FontAwesomeIcon icon={faExpand} /> </button>
                                <button type="button" className="btn btn-light ms-2" onClick={zoomOut}> <FontAwesomeIcon icon={faMinus} /> </button>
                                <button type="button" className="btn btn-light ms-2" onClick={zoomIn}><FontAwesomeIcon icon={faPlus} /></button>
                            </div>
                        </div>
                    </div>

                    <div className={`maindiv mt-3 overflow-hidden ${timelineDisplay === 'T' ? 'position-relative' : ''}`}>
                        <div className={`mb-0 nestedtabs rounded trashdonload slot_dashbord p-0 ${timelineDisplay === 'F' ? 'clip-hide' : ''}`}>
                            {/* <div className='d-flex'> */}
                            {/* <div className='door_name'>
                                    </div> */}
                            <div ref={timelineRef}></div>
                            {/* <div ref={timelineRef} className='door_left'></div> */}
                            {/* </div> */}
                        </div>
                        {showFlightDetails && (
                            <div className="SecondDiv">
                                <button className="close" onClick={handleCloseClick}>
                                    <FontAwesomeIcon icon={faXmark} />
                                </button>
                                <div className="girddtals_header">
                                    <h3>RFS - {' '}{[...new Set(
                                        showFlightDetails?.movement_info?.truck_no
                                            ?.map(truck_no => truck_no)
                                            .filter(Boolean)
                                    )].join(", ")}
                                    </h3>
                                    <p>Door No : {showFlightDetails.door_no}</p>

                                    <div className='d-flex actbtn'>

                                        <Button variant="light" > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
                                        <Dropdown>
                                            <Dropdown.Toggle variant="light" id="dropdown-basic" >
                                                <FontAwesomeIcon icon={faBolt} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item>Option</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>

                                        {timelineDisplay == 'F' ?
                                            <Button variant="light" > <FontAwesomeIcon icon={faPaperclip} /> Details</Button>
                                            : ''
                                        }
                                    </div>
                                </div>

                                {timelineDisplay == 'T' ?
                                    <>
                                        <div className='movment_history mt-3'>
                                            <h3>Status Updates</h3> {/*<Link to='#' onClick={movementHistoryClick}>View All</Link>*/}
                                        </div>
                                        <div className='update_info'>
                                            <ul>
                                                <li>
                                                    <span className=''>Truck No. :</span>
                                                    {/* <span className=''>{JSON.stringify(showFlightDetails)}</span> */}
                                                    <span className=''>{showFlightDetails?.movement_info?.truck_no}
                                                    </span>
                                                </li>
                                                <li>
                                                    <span className=''>Vehicle License :</span>
                                                    <span className=''>{showFlightDetails?.movement_info?.vehicle_license}</span>
                                                </li>
                                                <li>
                                                    <span className=''>Trailer License :</span>
                                                    <span className=''>{showFlightDetails?.movement_info?.trailer_license}</span>
                                                </li>
                                                <li>
                                                    <span>Driver 1 :</span>{' '}
                                                    <span>
                                                        {showFlightDetails.movement_info.driver1_first_name}{' '}{showFlightDetails.movement_info.driver1_last_name}
                                                    </span>
                                                </li>
                                                <li>
                                                    <span>Driver 2 :</span>{' '}
                                                    <span>
                                                        {showFlightDetails.movement_info.driver2_first_name}{' '}{showFlightDetails.movement_info.driver2_last_name}
                                                    </span>
                                                </li>
                                                <li>
                                                    <span className=''>Start Time :</span>
                                                    <span className=''>{showFlightDetails?.movement_info?.start_time}</span>
                                                </li>
                                                <li>
                                                    <span className=''>End Time :</span>
                                                    <span className=''>{showFlightDetails?.movement_info?.end_time}</span>
                                                </li>
                                                <li>
                                                    <span className=''>Handler Name :</span>
                                                    <span className=''>{showFlightDetails?.movement_info?.handler_name}</span>
                                                </li>
                                                {/* <li>
                                                            <span className=''>Movement Type :</span>
                                                            <span className=''>{showFlightDetails?.trip_type}</span>
                                                        </li>
                                                        <li>
                                                            <span className=''>Plan Date :</span>
                                                            <span className=''>{showFlightDetails?.movement_type?.date}</span>
                                                        </li>
                                                        <li>
                                                            <span className=''>Start Time :</span>
                                                            <span className=''>{showFlightDetails?.slot_start_time}</span>
                                                        </li>
                                                        <li>
                                                            <span className=''>End time :</span>
                                                            <span className=''>{showFlightDetails?.slot_end_time}</span>
                                                        </li>
                                                        <li>
                                                            <span className=''>Handler Name :</span>
                                                            <span className=''>{showFlightDetails?.movement_type?.handler_name}</span>
                                                        </li>
                                                        <li>
                                                            <span className=''>Trip Type :</span>
                                                            <span className=''>{showFlightDetails.trip_type}</span>
                                                        </li>
                                                        <li>
                                                            <span className=''>Truck No :</span>
                                                            <span className=''>{showFlightDetails?.movement_type?.truck_no}</span>
                                                        </li>
                                                        <li>
                                                            <span className=''>Vehicle No :</span>
                                                            <span className=''>{showFlightDetails?.movement_type?.vehicle_no}</span>
                                                        </li>
                                                        <li>
                                                            <span className=''>Driver name :</span>
                                                            <span className=''>{showFlightDetails?.movement_type?.driver_name}</span>
                                                        </li>

                                                        <li>
                                                            <span className=''>Trailer Licnse :</span>
                                                            <span className=''></span>
                                                        </li>
                                                        <li>
                                                            <span className=''>Station :</span>
                                                            <span className=''>{showFlightDetails?.movement_type?.station}</span>
                                                        </li> */}
                                                {/* <li>
                                                            <span className=''>Seal Nr.</span>
                                                            <span className=''></span>
                                                        </li> */}

                                            </ul>
                                        </div>
                                    </>
                                    :
                                    <div className="planemap">
                                        <img src={Planemap} />
                                    </div>
                                }

                                <ImageUpload
                                    ref={imageUploadRef}
                                    attachable_type={"uld"}
                                    attachable_id=""
                                    attachments=""
                                // onDeleteSuccess={() => loadDetails(selectedFlightDetails.uld_number)}
                                />
                                <ActivityComments
                                    commentable_type={"uld"}
                                    commentable_id=""
                                    allactivities=""
                                // onReloadDetails={loadDetails}
                                />

                            </div>
                        )}
                    </div>
                </div>
            </div>
            {/* </div> */}
            {/* </div>
            </div> */}
            <Modal show={doorDetailsModal} className="addfrom change_type" centered size="lg">
                <Modal.Header closeButton onClick={() => handleConfirmDoorDetails(false)}></Modal.Header>
                <Modal.Body>
                    <h3>Door Inactive - Door {activeDoorDetails?.door_no}</h3>
                    <p>If you choose inactive the door all slot change to other door</p>

                    {activeDoorDetails?.assigned_slots?.map((element, index) => (
                        <div className="door_inactive" key={index}>
                            <div className='d-flex justify-content-between align-items-center'>

                                <h4>{element.trip_type}</h4>
                                <Form.Check
                                    type="switch"
                                    id={`switch-${element.old_slot.slot_id}`}
                                    checked={slotStatuses[element.old_slot.slot_id] === 1}
                                    onChange={(e) => {
                                        const newStatus = e.target.checked ? 1 : 0;
                                        setSlotStatuses(prev => ({
                                            ...prev,
                                            [element.old_slot.slot_id]: newStatus
                                        }));
                                    }}
                                />

                            </div>
                            <div className='d-flex justify-content-between align-items-center'>
                                <div>
                                    <ul>
                                        <li>
                                            <span>Original</span>
                                            <span>Door 5</span>
                                        </li>
                                        <li>
                                            <span>13 Sep</span>
                                            <span>7:00 - 8:00</span>
                                        </li>
                                    </ul>
                                    {/* {element.old_slot.door_no}<br />
                                          {element.old_slot.start_time}<br />
                                          {element.old_slot.end_time} */}
                                </div>
                                <div>
                                    <FontAwesomeIcon icon={faArrowRight} />
                                </div>
                                <div >
                                    <ul>
                                        <li>
                                            <span>Changes</span>
                                            <span>Door 1</span>
                                        </li>
                                        <li>
                                            <span>14 Sep </span>
                                            <span>8:00 - 9:00</span>
                                        </li>
                                    </ul>
                                    {/* {element.new_slot.door_no}<br />
                                          {element.new_slot.start_time}<br />
                                          {element.new_slot.end_time} */}
                                </div>
                            </div>
                        </div>
                    ))}

                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex w-50 mx-auto are_bottom">
                        <Button variant="secondary" onClick={() => handleConfirmDoorDetails(false)}> No</Button>
                        <Button variant="primary" onClick={() => handleConfirmDoorDetails(true)}> Yes </Button>
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal show={modalShow} centered onHide={handleModalClose} className='addfrom add_door'>
                <Modal.Header closeButton>
                    <Modal.Title>Add Door</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm="12" className="mb-2">
                            <Form.Label>Warehouse</Form.Label>
                            <Select
                                name="warehouse_id"
                                options={warehouselist}
                                value={warehouselist?.find(opt => opt.value == activeWarehouse)}
                                onChange={(val) => handleSelectChange('warehouse_id', val)}
                                placeholder="Warehouse"
                            // className="form-control"
                            />
                        </Col>
                        <Col sm="6" className="mb-2">
                            <Form.Label>Door No</Form.Label>
                            <input
                                type="text"
                                name="door_no"
                                value={formData.door_no}
                                onChange={handleInputChange}
                                className="form-control"
                            />
                        </Col>
                        <Col sm="6" className="mb-2">
                            <Form.Label>Status</Form.Label>
                            <div className='act_status'>
                                <Button
                                    type="button"
                                    variant={formData.activity_status === 1 ? 'success' : 'light'}
                                    onClick={() => handleSelectChange('activity_status', { value: 1 })}
                                >
                                    Active
                                </Button>
                                <Button
                                    type="button"
                                    variant={formData.activity_status === 0 ? 'danger' : 'light'}
                                    onClick={() => handleSelectChange('activity_status', { value: 0 })}
                                >
                                    Inactive
                                </Button>
                            </div>
                        </Col>
                        <Col sm="6" className="mb-2">
                            <Form.Label>Trip Type</Form.Label>
                            <Select
                                name="trip_type_ids"
                                isMulti
                                options={tripType}
                                value={tripType.filter(opt => formData.trip_type_ids.includes(opt.value))}
                                onChange={(val) => handleSelectChange('trip_type_ids', val, 1)}
                                placeholder="Trip Type"
                            />
                        </Col>
                        <Col sm="6" className="mb-2">
                            <Form.Label>Cargo Type</Form.Label>
                            <Select
                                name="cargo_type_ids"
                                isMulti
                                options={cargoType}
                                value={cargoType.filter(opt => formData.cargo_type_ids.includes(opt.value))}
                                onChange={(val) => handleSelectChange('cargo_type_ids', val, 1)}
                                placeholder="Cargo Type"
                            />
                        </Col>
                        <Col sm="6" className="mb-2">
                            <Form.Label>Vehicle Type</Form.Label>
                            <Select
                                name="vehicle_type_ids"
                                isMulti
                                options={vehicleType}
                                value={vehicleType.filter(opt => formData.vehicle_type_ids.includes(opt.value))}
                                onChange={(val) => handleSelectChange('vehicle_type_ids', val, 1)}
                                placeholder="Vehicle Type"
                            />
                        </Col>
                        <Col sm="6" className="mb-2">
                            <Form.Label>Side Loading</Form.Label>
                            <div className="form-check form-check-inline">
                                <input
                                    type="radio"
                                    name="side_loading"
                                    className="form-check-input"
                                    checked={formData.side_loading === 1}
                                    onChange={() => handleBooleanChange('side_loading', 1)}
                                    id="side_loading_yes"
                                />
                                <Form.Label className="form-check-label mb-0" htmlFor='side_loading_yes'>Yes</Form.Label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input
                                    type="radio"
                                    name="side_loading"
                                    className="form-check-input"
                                    checked={formData.side_loading === 0}
                                    onChange={() => handleBooleanChange('side_loading', 0)}
                                    id="side_loading_no"
                                />
                                <Form.Label className="form-check-label mb-0" htmlFor='side_loading_no'>No</Form.Label>
                            </div>
                        </Col>
                        <hr />
                        <Col sm="12">
                            <Form.Label>Airline Access Type</Form.Label>
                            <div className="form-check form-check-inline">
                                <input
                                    type="radio"
                                    name="airline_assigment_rule"
                                    className="form-check-input"
                                    checked={formData.airline_assigment_rule === 1}
                                    onChange={() => handleBooleanChange('airline_assigment_rule', 1)}
                                    id="airline_assigment_rule_1"
                                />
                                <Form.Label className="form-check-label mb-0" htmlFor='airline_assigment_rule_1'>Yes</Form.Label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input
                                    type="radio"
                                    name="airline_assigment_rule"
                                    className="form-check-input"
                                    checked={formData.airline_assigment_rule === 0}
                                    onChange={() => handleBooleanChange('airline_assigment_rule', 0)}
                                    id="airline_assigment_rule_0"
                                />
                                <Form.Label className="form-check-label mb-0" htmlFor='airline_assigment_rule_0'>No</Form.Label>
                            </div>
                        </Col>
                        {formData.airline_assigment_rule === 1 && (
                            <>
                                <Col sm="6" className="mb-2">
                                    <Form.Label>Airline Access</Form.Label>
                                    <Select
                                        name="airline_access_type"
                                        options={airlineAccessOptions}
                                        value={airlineAccessOptions.find(opt => opt.value === formData.airline_access_type)}
                                        onChange={(val) => handleSelectChange('airline_access_type', val)}
                                        placeholder="Airline Access"
                                    />
                                </Col>
                                <Col sm="6" className="mb-2">
                                    <Form.Label>Airline Prefix</Form.Label>
                                    <Select
                                        name="airline_prefixes"
                                        isMulti
                                        options={airlinePrefixOptions}
                                        value={airlinePrefixOptions.filter(opt => formData.airline_prefixes.includes(opt.value))}
                                        onChange={(val) => handleSelectChange('airline_prefixes', val, 1)}
                                        placeholder="Airline Prefix"
                                    />
                                </Col>
                            </>
                        )}
                        <hr />
                        <Col sm="12">
                            <Form.Label>Special Cargo Handling</Form.Label>
                            <div className="form-check form-check-inline">
                                <input
                                    type="radio"
                                    name="special_cargo_handling"
                                    className="form-check-input"
                                    checked={formData.special_cargo_handling === 1}
                                    onChange={() => handleBooleanChange('special_cargo_handling', 1)}
                                    id="special_cargo_handling_1"
                                />
                                <Form.Label className="form-check-label mb-0" htmlFor='special_cargo_handling_1'>Yes</Form.Label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input
                                    type="radio"
                                    name="special_cargo_handling"
                                    className="form-check-input"
                                    checked={formData.special_cargo_handling === 0}
                                    onChange={() => handleBooleanChange('special_cargo_handling', 0)}
                                    id="special_cargo_handling_0"
                                />
                                <Form.Label className="form-check-label mb-0" htmlFor='special_cargo_handling_0'>No</Form.Label>
                            </div>
                        </Col>
                        {formData.special_cargo_handling === 1 && (
                            <>
                                <Col sm="6" className="mb-2">
                                    <Form.Label>Special Cargo Handling Type</Form.Label>
                                    <Select
                                        name="special_cargo_handling_type"
                                        options={specialCargoHandlingTypeOptions}
                                        value={specialCargoHandlingTypeOptions.find(opt => opt.value === formData.special_cargo_handling_type)}
                                        onChange={(val) => handleSelectChange('special_cargo_handling_type', val)}
                                        placeholder="Handling Type"
                                    />
                                </Col>
                                <Col sm="6" className="mb-2">
                                    <Form.Label>Special Cargo Type</Form.Label>
                                    <Select
                                        name="special_cargo_types"
                                        isMulti
                                        options={specialCargoType}
                                        value={specialCargoType.filter(opt => formData.special_cargo_types.includes(opt.value))}
                                        onChange={(val) => handleSelectChange('special_cargo_types', val, 1)}
                                        placeholder="Special Cargo Type"
                                    />
                                </Col>
                            </>
                        )}
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleAddDoor}>
                        {formData.door_id ? 'Update' : 'Add'} Door
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={confModal} onHide={closeConfirm} className="addfrom change_type" centered>
                <Modal.Header closeButton onClick={closeConfirm}></Modal.Header>
                <Modal.Body>
                    <h3>Set Door {selectedDoor} to Inactive</h3>
                    <div>
                        <Form.Label className='mt-3'>Reason for Inactivation</Form.Label>
                        <textarea rows={10} className='w-100 form-control' id="reason" placeholder="Reason for Inactivation" onChange={(e) => handleDoorStatusChange('reason', e.target.value)} value={doorStatusFormData.reason || ''}></textarea>
                    </div>

                    <div>
                        <Form.Label className='mt-3'>Remarks</Form.Label>
                        <textarea rows={10} className='w-100 form-control' id="remarks" placeholder="Remarks" onChange={(e) => handleDoorStatusChange('remarks', e.target.value)} value={doorStatusFormData.remarks || ''}></textarea>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex w-50 mx-auto are_bottom">
                        <Button variant="secondary" onClick={() => handleConfirmation(false)}> Cancel</Button>
                        <Button variant="primary" onClick={() => handleConfirmation(true)}> Update </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}
export default PlanningDashboard;
